import { BodyPartType, Prom } from "@rmh/defs";
import type {
  ExamFormTestChoice,
  SubjectiveExamForm,
  TestKey,
} from "@rmh/defs";
import { SUBJECTIVE_EXAMS } from "./subjectiveExamForm";

export const getExamByTestKey = (
  testKey: TestKey,
  exams: SubjectiveExamForm[]
) => {
  for (let i = 0; i < exams.length; i++) {
    const exam = exams[i];

    for (let j = 0; j < exam.examFormTests.length; j++) {
      const examFormTest = exam.examFormTests[j];

      if (examFormTest.testKey === testKey) {
        return {
          exam: examFormTest,
          step: i,
          subStep: j,
        };
      }
    }
  }

  return null;
};

export const getExamFormTestChoiceRows = (testKey: TestKey) => {
  const res = getExamByTestKey(testKey, SUBJECTIVE_EXAMS.exams);

  if (!res) {
    return [];
  }

  return (res.exam as ExamFormTestChoice).examFormChoiceRows ?? [];
};

export const getPromByBodyPart = (bodyPart: BodyPartType) => {
  if ([BodyPartType.Neck, BodyPartType.UpperBack].includes(bodyPart)) {
    return Prom.NeckDisabilityIndex;
  } else if (
    [
      BodyPartType.LeftShoulder,
      BodyPartType.RightShoulder,
      BodyPartType.LeftElbow,
      BodyPartType.RightElbow,
      BodyPartType.LeftWrist,
      BodyPartType.RightWrist,
      BodyPartType.LeftHand,
      BodyPartType.RightHand,
      BodyPartType.LeftUpperArm,
      BodyPartType.RightUpperArm,
      BodyPartType.LeftForearm,
      BodyPartType.RightForearm,
    ].includes(bodyPart)
  ) {
    return Prom.Quickdash;
  } else if (
    [BodyPartType.LowerBack, BodyPartType.Buttocks].includes(bodyPart)
  ) {
    return Prom.Oswestry;
  } else if (
    [
      BodyPartType.LeftFoot,
      BodyPartType.RightFoot,
      BodyPartType.LeftAnkle,
      BodyPartType.RightAnkle,
      BodyPartType.LeftKnee,
      BodyPartType.RightKnee,
      BodyPartType.LeftHip,
      BodyPartType.RightHip,
      BodyPartType.LeftUpperLeg,
      BodyPartType.RightUpperLeg,
      BodyPartType.LeftLowerLeg,
      BodyPartType.RightLowerLeg,
    ].includes(bodyPart)
  ) {
    return Prom.LowerExtremityFunctionalScale;
  }
  return Prom.LowerExtremityFunctionalScale;
};
